module.exports = __webpack_public_path__ + "img/chemise.b55ed97c.svg";